import type { ChatConversationSummary } from '@wundo/shared/chat.ts';
import { startOfWeek } from '@/lib/week.ts';

/** Conversations from the week the user is in, and everything before it. */
export interface ChatHistoryGroups {
  thisWeek: ChatConversationSummary[];
  earlier: ChatConversationSummary[];
}

/**
 * Two groups, not a date per row.
 *
 * Somebody looking for a conversation they had is looking for "the one from
 * this week" or "an older one" — an exact date only matters once they have
 * found the row, which is why it is the row's own second line. Weeks start on
 * Monday here whatever the agenda is set to: this is a heading over a list, not
 * a calendar anyone counts columns in.
 */
export function chatHistoryGroups(
  conversations: ChatConversationSummary[],
  now: Date = new Date(),
): ChatHistoryGroups {
  const weekStart = startOfWeek(now, 'monday').getTime();
  const thisWeek: ChatConversationSummary[] = [];
  const earlier: ChatConversationSummary[] = [];

  for (const conversation of conversations) {
    const at = new Date(conversation.last_message_at).getTime();
    (at >= weekStart ? thisWeek : earlier).push(conversation);
  }

  return { thisWeek, earlier };
}
